import { BsFillPersonFill } from "react-icons/bs";

const ProfileSideBox = ({ activeTab, setActiveTab, patientDetails }) => {
  const menuItems = ["Personal Information"];

  const fullName = `${patientDetails?.salutation || ""} ${
    patientDetails?.firstName || ""
  } ${patientDetails?.lastName || ""}`.trim();
  const patientCode = patientDetails?.code || "";

  return (
    <div className="w-full lg:w-[18%] border-b lg:border-b-0 lg:border-r lg:h-screen p-4">
      {/* Patient Info Header */}
      <div className="flex items-center mb-8 space-x-3">
        <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center text-blue-600 text-xl">
          <BsFillPersonFill />
        </div>
        <div className="leading-tight">
          <div className="leading-tight">
            <div className="font-semibold text-[#1d2f5b] text-base truncate w-[140px]">
              {fullName || "—"}
            </div>
            <div className="text-sm text-gray-500">{patientCode || "—"}</div>
          </div>
        </div>
      </div>

      {/* Tab Menu */}
      <ul>
        {menuItems.map((item, index) => (
          <li
            key={index}
            onClick={() => setActiveTab(item)}
            className={`py-2 px-3 rounded-lg cursor-pointer font-medium ${
              activeTab === item
                ? "text-green-600 font-medium"
                : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProfileSideBox;
